export const iconDashboard = require('./icon_dash.png');
export const iconLogout = require('./icon_logout.png');
